import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'rsuite';
import { queryClient } from '../../../../../App';
import { ButtonPrimary, DesignSystemSpecialModal as Modal, LoadingSpinerArea } from '../../../../../components';
import { AlertWithTimestamp } from '../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../data';
import { selectorPrecoAtacadoFiltersValue } from '../../../../../reducers/PrecoAtacado/filters/values';
import { CLOSE_WHOLESALE_MODAL, selectorWholesaleModals } from '../../../../../reducers/PrecoAtacado/modals';
import { RESET_PRECO_ATACADO_SELECTED_DATAPOINTS, selectorPrecoAtacadoSelectedDatapoints } from '../../../../../reducers/PrecoAtacado/selectedDatapoints';
import { POST_CLEAR_MASSIVE_FIELDS } from '../../pages/PrecoAtacado/services';
import { GET_CLEAR_MASSIVE_FIELDS_MODEL } from '../../pages/PrecoAtacado/utils';

const ERROR_MESSAGE = 'Erro ao limpar campos.';

const ModalClearWholesaleFields = () => {
  const dispatch = useDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const isOpen = useSelector(selectorWholesaleModals).CLEAR_FIELDS;

  const selectedDatapoints = useSelector(selectorPrecoAtacadoSelectedDatapoints);

  const filters = useSelector(selectorPrecoAtacadoFiltersValue);

  const handleClose = useCallback(() => {
    dispatch(CLOSE_WHOLESALE_MODAL('CLEAR_FIELDS'));
  }, [dispatch]);

  const handleConfirm = useCallback(async () => {
    const model = GET_CLEAR_MASSIVE_FIELDS_MODEL({ selectedDatapoints, filters });

    setIsSubmitting(true);

    try {
      const { status } = await POST_CLEAR_MASSIVE_FIELDS(model);

      // O endpoint responde 200; aceitar a faixa 2xx inteira para não tratar
      // um sucesso como erro caso o backend passe a responder 202/204.
      if (status < 200 || status >= 300) throw new Exception(ERROR_MESSAGE);

      Alert.success('Campos limpos com sucesso.');

      queryClient.invalidateQueries(['ipa/wholesale/datapoints']);

      dispatch(RESET_PRECO_ATACADO_SELECTED_DATAPOINTS());
    } catch {
      const { message } = new Exception(ERROR_MESSAGE);
      AlertWithTimestamp({ message });
    } finally {
      setIsSubmitting(false);
      handleClose();
    }
  }, [selectedDatapoints, filters, dispatch, handleClose]);

  return (
    <Modal.Root show={isOpen} onHide={handleClose}>
      <Modal.Header>
        <Modal.Icon icon="Loader2" />
      </Modal.Header>
      <Modal.Body>
        <Modal.Title>Limpar campos selecionados?</Modal.Title>
        <Modal.Content>Ao confirmar, todos os dados preenchidos nos campos escolhidos serão limpos.</Modal.Content>
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary theme="ghost" onClick={handleClose}>
          cancelar
        </ButtonPrimary>
        <ButtonPrimary onClick={handleConfirm} disabled={isSubmitting}>
          limpar
        </ButtonPrimary>
      </Modal.Footer>
      <LoadingSpinerArea />
    </Modal.Root>
  );
};

export default ModalClearWholesaleFields;
